export default "__VITE_ASSET__0$MJz1S8__"